import React from 'react';
import PropTypes from 'prop-types';
import {
	TableRowHeader,
	SubHeaderItem,
	StaticTableRowItem,
	GrowableTableRowItem,
	TableHeaderItemContainer,
} from './invoice-row.styled';
import {TooltipContainer} from '../../util-components/tooltip/TooltipContainer.js';

export const InvoiceRowHeader = ({
	intl,
	columns,
	invoicedAmount,
	paidAmount,
	unpaidAmount,
	totalUninvoicedMinutes,
	totalUninvoicedPrice,
	totalUninvoicedExpenses,
	totalUninvoiced,
	totalInvoicedAmount,
	stickyTopPosition,
	isInContainer,
	isEntryRow,
	invoiceId,
	customWidth,
}) => {
	const hasSubHeader =
		columns.simpleDate ||
		columns.client ||
		columns.status ||
		columns.date ||
		columns.invoicedAmount ||
		columns.paidAmount ||
		columns.unpaidAmount ||
		columns.dueDate ||
		columns.uninvoicedTimeRegMinutes ||
		columns.uninvoicedRetainerMinutes ||
		columns.uninvoicedFixedPrice ||
		columns.uninvoicedExpenses ||
		columns.uninvoicedAmount ||
		columns.overviewInvoicedAmount;

	return (
		<TableRowHeader stickyTopPosition={stickyTopPosition} isInContainer={isInContainer} entryRow={isEntryRow} header={true}>
			{columns.simpleDate && (
				<StaticTableRowItem className={'date'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.date'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.datePicker && (
				<StaticTableRowItem className={'datepicker'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.date'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.project && (
				<GrowableTableRowItem
					className={'project ' + (isEntryRow ? 'project-large entry-row' : '')}
					multiLine={hasSubHeader}
					header={true}
				>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.project'})}</TableHeaderItemContainer>
				</GrowableTableRowItem>
			)}
			{columns.name && (
				<StaticTableRowItem className={'name'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.name'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.notes && (
				<GrowableTableRowItem className={'notes'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.notes'})}</TableHeaderItemContainer>
				</GrowableTableRowItem>
			)}
			{columns.invoiceId && (
				<StaticTableRowItem className={'invoiceId'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{invoiceId}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.invoiceName && (
				<GrowableTableRowItem className={'invoiceName'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'project_section.invoice_name'})}
					</TableHeaderItemContainer>
				</GrowableTableRowItem>
			)}
			{columns.description && (
				<StaticTableRowItem className={'description'} multiLine={hasSubHeader} header={true} customWidth={customWidth}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.description'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.xeroAccount && (
				<StaticTableRowItem className={'xero-account'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'integrations.xero.xero_account'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.quickbooksItem && (
				<StaticTableRowItem className={'quickbooks-item'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'integrations.quickbooks.item_or_service'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.economicProduct && (
				<StaticTableRowItem className={'economic-product'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'integrations.economic.product'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.sageIntacctAccount && (
				<StaticTableRowItem className={'sageIntacct-account'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'integrations.sageIntacct.account'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.sageIntacctLocation && (
				<StaticTableRowItem className={'sageIntacct-location'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'integrations.sageIntacct.location'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.client && (
				<GrowableTableRowItem className={'client'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.client'})}</TableHeaderItemContainer>
				</GrowableTableRowItem>
			)}
			{columns.quantity && (
				<StaticTableRowItem className={'quantity'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.quantity'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.unitPrice && (
				<StaticTableRowItem className={'price-input'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.unit_price'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.discount && (
				<StaticTableRowItem className={'percentage'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'project_section.xero_modal_table_discount'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.tax && (
				<StaticTableRowItem className={'percentage'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.tax'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.totalPrice && (
				<StaticTableRowItem className={'totalPrice'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'expense_item_modal.total_price'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}

			{columns.status && (
				<StaticTableRowItem className={'status'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.status'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.date && (
				<StaticTableRowItem className={'date'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'invoicing.invoice_date'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.invoicedAmount && (
				<StaticTableRowItem className={'price-small'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TooltipContainer text={intl.formatMessage({id: 'invoicing.invoiced_tooltip'})}>
						<TableHeaderItemContainer>{intl.formatMessage({id: 'common.total_invoiced'})}</TableHeaderItemContainer>
						{hasSubHeader ? (
							<TableHeaderItemContainer className={'sub-header'}>
								<SubHeaderItem>{invoicedAmount}</SubHeaderItem>
							</TableHeaderItemContainer>
						) : null}
					</TooltipContainer>
				</StaticTableRowItem>
			)}
			{columns.paidAmount && (
				<StaticTableRowItem className={'price-small'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TooltipContainer text={intl.formatMessage({id: 'invoicing.paid_tooltip'})}>
						<TableHeaderItemContainer>
							{intl.formatMessage({id: 'settings_subscription.paid'})}
						</TableHeaderItemContainer>
						{hasSubHeader ? (
							<TableHeaderItemContainer className={'sub-header'}>
								<SubHeaderItem>{paidAmount}</SubHeaderItem>
							</TableHeaderItemContainer>
						) : null}
					</TooltipContainer>
				</StaticTableRowItem>
			)}
			{columns.paidInput && (
				<StaticTableRowItem className={'price-input'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'settings_subscription.paid'})}
					</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.unpaidAmount && (
				<StaticTableRowItem className={'price-small'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TooltipContainer text={intl.formatMessage({id: 'invoicing.unpaid_tooltip'})}>
						<TableHeaderItemContainer>
							{intl.formatMessage({id: 'settings_subscription.unpaid'})}
						</TableHeaderItemContainer>
						{hasSubHeader ? (
							<TableHeaderItemContainer className={'sub-header'}>
								<SubHeaderItem>{unpaidAmount}</SubHeaderItem>
							</TableHeaderItemContainer>
						) : null}
					</TooltipContainer>
				</StaticTableRowItem>
			)}
			{columns.dueDate && (
				<StaticTableRowItem className={'date'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.due_date'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.uninvoicedTimeRegMinutes && (
				<StaticTableRowItem className={'hours-price-header'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'common.uninvoiced_time_registrations'})}
					</TableHeaderItemContainer>
					{hasSubHeader ? (
						<TableHeaderItemContainer className={'sub-header'}>
							<SubHeaderItem className={'hours'}>{totalUninvoicedMinutes}</SubHeaderItem>
							<SubHeaderItem className={'price'}>{totalUninvoicedPrice}</SubHeaderItem>
						</TableHeaderItemContainer>
					) : null}
				</StaticTableRowItem>
			)}
			{columns.uninvoicedRetainerMinutes && (
				<StaticTableRowItem className={'hours-price-header'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'common.uninvoiced_locked_periods'})}
					</TableHeaderItemContainer>
					{hasSubHeader ? (
						<TableHeaderItemContainer className={'sub-header'}>
							<SubHeaderItem className={'hours'}>{totalUninvoicedMinutes}</SubHeaderItem>
							<SubHeaderItem className={'price'}>{totalUninvoicedPrice}</SubHeaderItem>
						</TableHeaderItemContainer>
					) : null}
				</StaticTableRowItem>
			)}
			{columns.uninvoicedFixedPrice && (
				<StaticTableRowItem className={'hours-price-header'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'common.uninvoiced_fixed_price'})}
					</TableHeaderItemContainer>
					{hasSubHeader ? (
						<TableHeaderItemContainer className={'sub-header'}>
							<SubHeaderItem>{totalUninvoicedPrice}</SubHeaderItem>
						</TableHeaderItemContainer>
					) : null}
				</StaticTableRowItem>
			)}
			{columns.uninvoicedExpenses && (
				<StaticTableRowItem className={'price'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>
						{intl.formatMessage({id: 'common.uninvoiced_expenses'})}
					</TableHeaderItemContainer>
					{hasSubHeader ? (
						<TableHeaderItemContainer className={'sub-header'}>
							<SubHeaderItem>{totalUninvoicedExpenses}</SubHeaderItem>
						</TableHeaderItemContainer>
					) : null}
				</StaticTableRowItem>
			)}
			{columns.uninvoicedAmount && (
				<StaticTableRowItem className={'price'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.total_uninvoiced'})}</TableHeaderItemContainer>
					{hasSubHeader ? (
						<TableHeaderItemContainer className={'sub-header'}>
							<SubHeaderItem>{totalUninvoiced}</SubHeaderItem>
						</TableHeaderItemContainer>
					) : null}
				</StaticTableRowItem>
			)}
			{columns.overviewInvoicedAmount && (
				<StaticTableRowItem className={'price'} alignRight={true} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.total_invoiced'})}</TableHeaderItemContainer>
					{hasSubHeader ? (
						<TableHeaderItemContainer className={'sub-header'}>
							<SubHeaderItem>{totalInvoicedAmount}</SubHeaderItem>
						</TableHeaderItemContainer>
					) : null}
				</StaticTableRowItem>
			)}
			{columns.export && (
				<StaticTableRowItem className={'export'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer>{intl.formatMessage({id: 'common.export'})}</TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.integrationLink && (
				<StaticTableRowItem className={'integration-links'} multiLine={hasSubHeader} header={true}>
					<TableHeaderItemContainer></TableHeaderItemContainer>
				</StaticTableRowItem>
			)}
			{columns.hasContextMenu && (
				<StaticTableRowItem
					width={20}
					className={'context-menu ' + (isEntryRow ? 'entry-row' : '')}
				></StaticTableRowItem>
			)}
		</TableRowHeader>
	);
};

InvoiceRowHeader.propTypes = {
	intl: PropTypes.shape({
		formatMessage: PropTypes.func,
	}),

	/**
	 * Entry status
	 */
	client: PropTypes.string,

	/**
	 * Entry status
	 */
	status: PropTypes.string,

	/**
	 * Entry date
	 */
	date: PropTypes.string,

	/**
	 * Entry date
	 */
	dueDate: PropTypes.string,

	/**
	 * paidAmount
	 */
	paidAmount: PropTypes.string,

	/**
	 * unpaidAmount
	 */
	unpaidAmount: PropTypes.string,

	/**
	 * invoicedAmount
	 */
	invoicedAmount: PropTypes.string,

	/**
	 * Uninvoiced minutes
	 */
	totalUninvoicedMinutes: PropTypes.number,

	/**
	 * Custom width
	 */
	customWidth: PropTypes.number,

	/**
	 * Uninvoiced time registration price
	 */
	totalUninvoicedPrice: PropTypes.string,

	/**
	 * Uninvoiced expenses price
	 */
	totalUninvoicedExpenses: PropTypes.string,

	/**
	 * Uninvoiced time registration + uninvoiced expenses
	 */
	totalUninvoiced: PropTypes.string,

	/**
	 * Name of the project
	 */
	totalInvoicedAmount: PropTypes.string,

	/**
	 * Currency symbol
	 */
	currencySymbol: PropTypes.string,

	/**
	 * value of the css element top if the header should be on position sticky
	 */
	stickyTopPosition: PropTypes.number,

	/**
	 * Elements to show (or not) in the row
	 */
	columns: PropTypes.shape({
		project: PropTypes.bool,
		invoiceName: PropTypes.bool,
		invoiceId: PropTypes.bool,
		uninvoicedTimeRegMinutes: PropTypes.bool,
		uninvoicedTimeRegPrice: PropTypes.bool,
		uninvoicedExpenses: PropTypes.bool,
		uninvoicedAmount: PropTypes.bool,
		invoicedAmount: PropTypes.bool,
		client: PropTypes.bool,
		description: PropTypes.bool,
		xeroAccount: PropTypes.bool,
		quickbooksItem: PropTypes.bool,
		economicProduct: PropTypes.bool,
		sageIntacctLocation: PropTypes.bool,
		sageIntacctAccount: PropTypes.bool,
		quantity: PropTypes.bool,
		unitPrice: PropTypes.bool,
		tax: PropTypes.bool,
		discount: PropTypes.bool,
		totalPrice: PropTypes.bool,
		status: PropTypes.bool,
		name: PropTypes.bool,
		date: PropTypes.bool,
		simpleDate: PropTypes.bool,
		datePicker: PropTypes.bool,
		notes: PropTypes.bool,
		dueDate: PropTypes.bool,
		paidAmount: PropTypes.bool,
		paidInput: PropTypes.bool,
		unpaidAmount: PropTypes.bool,
		overviewInvoicedAmount: PropTypes.bool,
		uninvoicedFixedPrice: PropTypes.bool,
		uninvoicedRetainerMinutes: PropTypes.bool,
		uninvoicedRetainerPrice: PropTypes.bool,
		export: PropTypes.bool,
		integrationLink: PropTypes.bool,
		hasContextMenu: PropTypes.bool,
	}).isRequired,
	onSortByChange: PropTypes.func,
	/**
	 * Neccessary information to know the context of the list.
	 * Lists in a containers are the one in sprints or miletsones.
	 */
	isInContainer: PropTypes.bool,
	isEntryRow: PropTypes.bool,
	invoiceId: PropTypes.element,
	tracking: PropTypes.func,
	sortBy: PropTypes.shape({
		column: PropTypes.string,
		ascending: PropTypes.bool,
	}),
};

InvoiceRowHeader.defaultProps = {
	intl: {
		formatMessage: ({id}) => id,
	},
	tracking: {
		trackEvent: ({tracked}) => tracked,
	},
	stickyTopPosition: null,
	sortBy: {column: null, ascending: true},
};
